import React from "react";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";

import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";

import AccessibilityTooltip from "./AccessibilityTooltip";

const useStyles = makeStyles((theme) => ({
    langsWrap: {
        display: "inline-flex",
        alignItems: "center",
    },
    reactCountryFlag: {
        fontSize: 24,
        display: "inline-block",
        width: "1em",
        height: "1em",
        verticalAlign: "middle",
    },
    toolbarRoundedIcon: {},
}));

const LangSwitcher = (props) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    const history = useHistory();

    // Set initial language attribute
    React.useEffect(() => {
        const currentLang = i18n.language || localStorage.getItem("lang") || "pl";
        document.documentElement.setAttribute("lang", currentLang);
        document.querySelector("html").setAttribute("lang", currentLang);
    }, [i18n.language]);

    const changeLanguage = (lng) => {
        document.documentElement.setAttribute("lang", lng);
        document.querySelector("html").setAttribute("lang", lng);

        localStorage.setItem("lang", lng);
        localStorage.setItem("i18nextLng", lng);
        i18n.changeLanguage(lng);

        const _pathLang = `/${lng}`;
        const newUrl = `${_pathLang}${history.location.pathname}${history.location.search}${history.location.hash}`;

        window.location.replace(newUrl);
    };

    return (
        <div className={classes.langsWrap} {...props}>
            {i18n.language === "en" ? (
                <AccessibilityTooltip
                    arrow={false}
                    placement="bottom"
                    title={t(`Switch to Polish version / Przełącz na wersję polską`)}
                >
                    <IconButton
                        color="primary"
                        className={classes.toolbarRoundedIcon}
                        aria-label={t(`Switch to Polish version / Przełącz na wersję polską`)}
                        onClick={() => changeLanguage("pl")}
                    >
                        <img src={`/icons/flag-pl.svg`} alt="" className={classes.reactCountryFlag} />
                    </IconButton>
                </AccessibilityTooltip>
            ) : (
                <AccessibilityTooltip
                    arrow={false}
                    placement="bottom"
                    title={t(`Przełącz na wersję angielską / Switch to English version`)}
                >
                    <IconButton
                        color="primary"
                        className={classes.toolbarRoundedIcon}
                        aria-label={t(`Przełącz na wersję angielską / Switch to English version`)}
                        onClick={() => changeLanguage("en")}
                    >
                        <img src={`/icons/flag-en.svg`} alt="" className={classes.reactCountryFlag} />
                    </IconButton>
                </AccessibilityTooltip>
            )}
        </div>
    );
};

export default LangSwitcher;
